///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { LOCALE_ID, NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { GtthAccessDeniedModalComponent } from './access-denied/accessdenied.component';
import { GtthAccessDeniedModalService } from './access-denied/accessdenied.service';
import { AutoLogoutModalComponent } from './auto-logout-modal/auto-logout-modal.component';

import { FeetConvert } from './pipes/pipe.FeetConvert';
import { GtthPriceEditComponent } from './prices/price-edit/price-edit.component';
import { GtthPriceShowComponent } from './prices/price-show/price-show.component';
import { GtthSinglePriceShowComponent } from './prices/single-price-show/single-price-show.component';
import { GtthImgZoomComponent } from './img-zoom/img-zoom.component';
import { GtthProductRadioConfigComponent } from './product-radio-config/product-radio-config.component';

import { GtthShareDirectivesModule } from './shared-directives.module';
import { GtthSharePipesModule } from './shared-pipes.module';
import { GtthShareComponentsModule } from './shared-components.module';
import { ReactiveFormsModule } from '@angular/forms';
import { GtthBreadCrumbsComponent } from './breadcrumb/breadcrumbs.coponent';
import { GtthDateFormatComponent } from './global-components/date-format.component';
import { GtthReactiveFormsModule } from './reactive-forms/reactie-forms.module';
import { GtthSharedLibsModule } from './shared-libs.module';
import { MatDialogClose } from '@angular/material/dialog';
import { ContextSensitiveHelpComponent } from './context-sensitive-help/ctx-sensitive-help.component';
import { TabsNavComponent } from './tabs-nav/tabs-nav.component';
import { SuiSvgIconComponent, SuiTooltipDirective, SuiTranslatePipe } from '@siklu/sui-lib';
import { GtthNumberInputValidationDirective } from './directives/validation-directives/number-input.directive';

@NgModule({
    imports: [
        GtthSharedLibsModule,
        ReactiveFormsModule,
        GtthShareDirectivesModule,
        GtthSharePipesModule,
        GtthShareComponentsModule,
        GtthReactiveFormsModule,
        MatDialogClose,
        ContextSensitiveHelpComponent,
        TabsNavComponent,
        SuiSvgIconComponent,
        SuiTranslatePipe,
        SuiTooltipDirective,
        FeetConvert,
        GtthNumberInputValidationDirective
    ],
    declarations: [
        GtthAccessDeniedModalComponent,
        AutoLogoutModalComponent,
        GtthPriceEditComponent,
        GtthPriceShowComponent,
        GtthSinglePriceShowComponent,
        GtthImgZoomComponent,
        GtthProductRadioConfigComponent,
        GtthBreadCrumbsComponent,
        GtthDateFormatComponent
    ],
    providers: [
        {
            provide: LOCALE_ID,
            useValue: 'en'
        },
        Title,
        GtthAccessDeniedModalService
    ],
    exports: [
        GtthSharedLibsModule,
        ReactiveFormsModule,
        GtthShareDirectivesModule,
        GtthSharePipesModule,
        GtthShareComponentsModule,
        GtthAccessDeniedModalComponent,
        AutoLogoutModalComponent,
        FeetConvert,
        GtthPriceEditComponent,
        GtthPriceShowComponent,
        GtthSinglePriceShowComponent,
        GtthImgZoomComponent,
        GtthProductRadioConfigComponent,
        GtthBreadCrumbsComponent,
        GtthDateFormatComponent,
        GtthReactiveFormsModule
    ]
})
export class GtthSharedCommonModule {}
